import { getLinkHref } from 'medialoopster/rest';

import { AssetCollection } from './types';

// eslint-disable-next-line import/prefer-default-export
export const isAssetCollectionEmpty = (collection: AssetCollection): boolean =>
  !getLinkHref(collection, 'device') &&
  collection.video_asset_count + collection.image_asset_count + collection.audio_asset_count === 0;
